import styled, { css, keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Spinner = styled.div<{
  size?: string;
  color?: string;
}>`
  ${({ theme, size, color }) => css`
    border: 4px solid ${theme.palette.black(0.1)};
    border-left-color: ${color ?? theme.palette.primary.main};
    border-radius: ${theme.borderRadius.full};
    width: ${size ?? '24px'};
    height: ${size ?? '24px'};
    animation: ${spin} 1s linear infinite;
  `}git a
`;

export default Spinner;
